import { CancelButton, Error, InputForm, SubmitButton } from "components";
import {
  ResetCommercialPasswordInput,
  ResetCommercialPasswordInputError,
} from "modules/user_management/commercial_user/user/state/actionType";

interface Formprops {
  header: string;
  loading: boolean;
  formData: ResetCommercialPasswordInput;
  error: ResetCommercialPasswordInputError;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
  onClose: () => void;
}

const ResetDcddPasswordForm: React.FC<Formprops> = ({
  header,
  loading,
  formData,
  error,
  handleChange,
  handleSubmit,
  onClose,
}) => {
  return (
    <>
      <div className="px-4 pb-4">
        <h2 className="text-center text-xl font-bold pb-4">{header}</h2>
        <form className="">
          <div>
            <InputForm
              label="Enter password"
              value={formData.password}
              id="password"
              name="password"
              onChange={handleChange}
            />
            {error.password && <Error>{error.password}</Error>}
          </div>

          <div>
            <InputForm
              label="Confirm password"
              value={formData.confirm_password}
              id="confirm_password"
              name="confirm_password"
              onChange={handleChange}
            />
            {error.confirm_password && <Error>{error.confirm_password}</Error>}
          </div>
          <div className="pt-3 flex justify-between">
            <CancelButton type="button" onClick={onClose} />
            <SubmitButton onClick={handleSubmit} loading={loading} />
          </div>
        </form>
      </div>
    </>
  );
};

export default ResetDcddPasswordForm;
